import React from 'react';
import AsyncSelect from 'react-select/async';
import { useEffect, useState } from 'react';
import { colors } from '../../../theme';

const SelectUserRoleNew = props => {
  const [options, setOptions] = useState([
    { label: 'Administrador', value: 'ADMIN' },
    { label: 'Operador', value: 'OPERATIVE' },
  ]);
  const [value, setValue] = useState(null);
  const color = 'black';
  const colorBg = 'white';
  const colorHover = colors.primary['50'];
  const colorHoverOption = colors.primary['200'];

  useEffect(() => {
    let { value } = props;
    setValue(value);
  }, [props.value]);

  const handleChange = selectedValue => {
    setValue(selectedValue);
    let event = { target: {} };
    event.target.name = props.name ? props.name : 'select-options-nameless';
    event.target.value = selectedValue ? selectedValue.value : null;
    event.target.type = 'react-select';
    props.onChange(event);
  };

  const customStyles = {
    control: provided => ({
      ...provided,
      border: '0px solid black',
      backgroundColor: 'none',
      outline: 'none',
      '&:hover': { backgroundColor: colorHover },
    }),
    placeholder: () => ({
      color: color,
      fontSize: '16px',
      marginLeft: '8px',
      '&:hover': { fontSize: '15px' },
    }),

    singleValue: () => ({
      color: color,
    }),

    menuList: provided => ({
      ...provided,
      color: color,
      backgroundColor: colorBg,
    }),
    option: (provider, state) => ({
      ...provider,
      '&:hover': { backgroundColor: colorHoverOption },
      backgroundColor: state.isFocused ? colorHoverOption : 'none',
      color: color,
    }),
  };

  return (
    <AsyncSelect
      styles={customStyles}
      onChange={handleChange}
      defaultOptions={options}
      value={
        value !== null ? options.find(option => option.value === value) : null
      }
      isClearable={true}
      name={props.name}
      required={props.required}
      isDisabled={props.disabled}
      placeholder={props.placeholder ? props.placeholder : 'No definido'}
    />
  );
};

export default SelectUserRoleNew;
